import { useGLTF } from "@react-three/drei";
import React, { useRef, useState } from "react";
import { Vector3 } from "three";
import { useFrame } from "@react-three/fiber";
import { stageObject } from "../interface";

export const Earth = ({ url, scale }: stageObject) => {
  const { scene: earth } = useGLTF(url, "/draco/");
  const earthRef = useRef<any>();
  const [direction] = useState(() => new Vector3(0, 0.6, 5));

  useFrame(() => {
    if (earthRef.current) {
      earthRef.current.position.add(direction.multiplyScalar(0.01));
      earthRef.current.rotation.y += 0.0001;
    }
  });

  return (
    <>
      <primitive
        ref={earthRef}
        object={earth}
        rotation={[0, 1, 0]}
        scale={scale}
        castShadow
      />
      <directionalLight
        position={[10, 10, 15]} // 确保光源位于地球的外部
        intensity={2}
        castShadow
        shadow-mapSize-width={1024}
        shadow-mapSize-height={1024}
        shadow-camera-far={50}
        shadow-camera-near={0.1}
        shadow-camera-left={-10}
        shadow-camera-right={10}
        shadow-camera-top={10}
        shadow-camera-bottom={-10}
      ></directionalLight>
    </>
  );
};
